define(['jquery', 'auth'], function ($, auth) {
    var _internals = {
        getCookie: function (name) {
            var cookieValue = null;
            if (document.cookie && document.cookie !== '') {
                var cookies = document.cookie.split(';');
                for (var i = 0; i < cookies.length; i++) {
                    var cookie = jQuery.trim(cookies[i]);
                    // Does this cookie string begin with the name we want?
                    if (cookie.substring(0, name.length + 1) === (name + '=')) {
                        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                        break;
                    }
                }
            }
            return cookieValue;
        },
        initAjax: function () {
            $.ajaxPrefilter(function (options) {
                if ( !options.beforeSend) {
                    options.beforeSend = function (xhr) {
                        xhr.setRequestHeader("X-XSRF-Token", _internals.getCookie("XSRF-TOKEN"));
                    }
                }
            });
        },
        initRaven: function () {
            require(['https://cdn.ravenjs.com/3.19.1/raven.min.js'], function (Raven) {
                Raven.config(window.sentry_dsn, window.sentry_options).install();
                if (window.raven_user_context !== null) {
                    Raven.setUserContext(window.raven_user_context);
                }
            });
        },
        loadFonts: function () {
            require(['//ajax.googleapis.com/ajax/libs/webfont/1/webfont.js'], function (WebFont) {
                WebFont.load({google: {families: ['PT Sans', 'PT Serif']}});
            });
        },
        initMobileMenu: function () {
            if ($('#mobileMenuToggle').data('mobile') !== true) {
                return;
            }
            window.mobilePanel = {
                container: $('#mobilePanel'),
                items: $('#mobilePanel > .items'),
                header: $('#mobilePanel > .header > span'),
                opened: false,
                current: {},
                path: [],
                oldParent: null
            };

            $.ajax({
                dataType: "html",
                url: '/services/get-menu',
                type: 'post',
                success: function (menu) {
                    $('#catalog-menu').html(menu);
                }
            });

            $('[data-toggle="mobilemenu"]').each(function () {
                var toggle = $(this);
                toggle.on('click', _internals.menuNavigate);
            });

            $('#mobilePanel')
                .on('click', '[data-action="close"]', _internals.closeMenu)
                .on('click', 'a.back', _internals.menuNavigate)
                .on('click', '.items > li > a', _internals.menuNavigate);
        },
        closeMenu: function (e) {
            e.preventDefault();

            if (mobilePanel.oldParent !== null) {
                var item = mobilePanel.items.find(' > li > :first-child');
                item.appendTo(mobilePanel.oldParent);
                mobilePanel.oldParent = null;
            }

            mobilePanel.container.removeClass('open');
            mobilePanel.items.empty();
            window.mobilePanel.path = [];
            window.mobilePanel.current = null;
            window.mobilePanel.opened = false;
        },
        menuNavigate: function (e) {
            var element = $(this);
            var data = element.data();
            if (data.text === undefined) {
                data.text = element.text();
            }

            if (!mobilePanel.opened) {
                mobilePanel.container.addClass('open');
                mobilePanel.opened = true;
            }

            if (data.back) {
                if (mobilePanel.path.length > 0) {
                    data = mobilePanel.current = mobilePanel.path.pop();
                }
            } else {
                mobilePanel.path.push(mobilePanel.current);
                mobilePanel.current = data;
            }

            if ($(data.target).length) {
                e.preventDefault();
                mobilePanel.items.empty();

                $(data.target).find('[data-parent="' + data.target + '"]').each(function () {
                    var element = $(this);
                    var item = element.find('> a').clone();

                    if (element.find('ul').length) {
                        item.addClass('has-children');
                    }
                    $('<li/>').append(item).appendTo(mobilePanel.items);
                });

                $(data.target).find('form').each(function () {
                    var element = $(this);
                    if (data.move === true) {
                        item = element;
                        mobilePanel.oldParent = item.parent();
                    } else {
                        var item = element.clone();
                        item.id = "mobileForm";
                        item.removeClass();
                        _internals.initAutocomplete(item.find('input'));
                    }
                    $('<li/>').append(item).appendTo(mobilePanel.items);
                });

                mobilePanel.header.text(data.text);

                if (mobilePanel.path.length > 1) {
                    mobilePanel.container.find('a.back').removeClass('hidden');
                } else {
                    mobilePanel.container.find('a.back').addClass('hidden');
                }
            }
        },
        initUI: function () {
            require(['modals', 'pagination', 'cart','compare'], function (modals, pagination, cart, compare) {
                modals.init();
                pagination.init();
                cart.bindToUI();
                compare.bindToUI();
            });
            require(['autocomplete'], function () {
                $('#search-text').autocomplete({
                    serviceUrl: '/services/product/search',
                    minChars: 3,
                    deferRequestBy: 200,
                    preventBadQueries: false,
                    triggerSelectOnValidInput: false,
                    onSelect: function (suggestion) {
                        window.location.href = suggestion.data;
                    },
                    formatResult: function (suggestion) {
                        return suggestion.view;
                    }
                });
            });
            require(['jquery'], function ($) {
               $('a.dropdown-link').on('click', function (e) {
                   var dropdown = $(this).find('+ .menu-dropdown');

                   if (dropdown.length > 0) {
                       e.preventDefault();
                   }

                   var active = dropdown.hasClass('active');

                   $('.menu-dropdown').removeClass('active');

                   if (!active) {
                       dropdown.addClass('active');
                   }
                });
               $('.menu-dropdown').on('click', 'a[data-action=close]', function (e) {
                   e.preventDefault();
                   $('.menu-dropdown').removeClass('active');
               });
            });
        }
    };

    return {
        init: function () {
            _internals.initRaven();
            _internals.initAjax();
            auth.init();
        },
        initUI: function () {
            _internals.loadFonts();
            _internals.initUI();
            _internals.initMobileMenu();
        }
    }
});

function validateEmail(email, validator, $field) {
    var dfd = $.Deferred();

    if (window.validateXHR !== undefined) {
        window.validateXHR.abort();
    }

    window.validateXHR = $.ajax({
        url: $field.data('url'),
        method: 'post',
        data: {
            value: email,
            check: $field.data('check'),
            _token: $field.data('token')
        },
        dataType: 'json',
        success: function (response) {
            dfd.resolve(response);
        },
        error: function (jqXHR, textStatus, errorThrown) {
            dfd.resolve({valid: true, message: ''});
            if (textStatus !== 'abort') {
                throw new Error('Error validating email. Status: ' + textStatus + ', error: ' + errorThrown + ', response: ' + jqXHR.responseText);
            }
        }
    });

    return dfd.promise();
}
